// export const stringToColour = function(stringInput: string): string {
//     let stringUniqueHash = Array.from(stringInput).reduce((acc, char) => {
//         return char.charCodeAt(0) + ((acc << 5) - acc);
//     }, 0);
//     return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
//
// }
export const stringToColour = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
  const color = Math.floor(Math.abs(((Math.sin(hash) * 10000) % 1) * 16777216)).toString(16);
  return '#' + Array(6 - color.length + 1).join('0') + color;
};
